import React from 'react'
import { SkeletonCard, SkeletonText, SpookySkeleton } from '@offerzen/pinata'

import styles from './styles'

const SkeletonMobileCandidateProfileScene = () => {
  return (
    <div aria-label="Loading">
      <SpookySkeleton>
        <SkeletonCard className={styles.card} />
        <SkeletonText theme="dark" width={200} className={styles.text} />
        <SkeletonText theme="dark" width={200} className={styles.text} />
      </SpookySkeleton>
    </div>
  )
}

export default SkeletonMobileCandidateProfileScene
